<template>
    <div class="container-fluid">
        <div class="row py-3">
            <div class="designRowOrga">
                <div class="h3Organization">
                    <h3>Roles</h3>
                </div>
                <router-link class="text-decoration-none btn-container" v-if="permissions.includes('create role') && roles.length > 0"
                             to="/create-role">
                    <span>Create Role</span>
                </router-link>
            </div>

            <div class="tabcontent">

                <div class="fullInputs mb-4 pt-3">
                    <div class="twoInputs">
                        <div class="btnInsideInput">
                            <input type="text" id="free_search" class="form-control" v-model="search"
                                   placeholder="Search" autocomplete="off"
                                   @input="searchHandler" maxlength="50">

                            <button @click="getRoles" ref="buttonSearch">
                                <img src="../../../assets/images/SearchIcon.png" alt="">
                            </button>
                        </div>
                    </div>
                    <div class="oneInput">
                        <select id="filter_dates" class="form-select" v-model="sort" @change="getRoles">
                            <option selected disabled value="false">Sort by Date</option>
                            <option value="asc">Oldest</option>
                            <option value="desc">Latest</option>
                        </select>
                    </div>
                </div>
                <div class="table-container" v-if="roles.length > 0">

                    <TableComponent :thead="thead" :tbody="roles" @sort="SortRole" :keys="keys"
                                    model="roles" name="role"
                                    updateUrl="/edit-roles" @update="updateRole"/>

                    <div class="paginationLink">
                        <pagination :data="laravelData" @pagination-change-page="getRoles" :limit="3">
                            <template #prev-nav>
                                <span>Previous</span>
                            </template>
                            <template #next-nav>
                                <span>Next</span>
                            </template>
                        </pagination>
                    </div>
                </div>

                <div v-else class="d-flex flex-column justify-content-center align-items-center gap-2 h-75 m-auto">
                    <div class="h3Organization">
                        <h3 v-if="!isSearch">You Don't Have Any Roles Yet</h3>
                        <h3 v-else>No Data</h3>
                    </div>
                    <router-link class="text-decoration-none btn-container  btn-container-no-data"
                                 v-if="permissions.includes('create role') && roles.length === 0 && !isSearch"
                                 to="/create-role">
                        <span>Create Role</span>
                    </router-link>
                </div>


            </div>

        </div>
    </div>
</template>

<script>
    import TableComponent from "../../components/TableComponent";
    import LaravelVuePagination from "laravel-vue-pagination";
    import roles from "../../../api-services/roles";

    export default {
        name:'plateform_permissions-index',
        data(){
            return{
                role:'',
                thead: ['Role Name' , 'Members'],
                keys: ['name' , 'users_count'],
                roles: [],
                filteredArray: [],
                permissions:[],
                originalRoles: [],
                laravelData: {},
                error: null,
                search: '',
                sort: false,
                state: false
            }
        },
        mounted(){
            this.role = this.$store.state.auth.user.data.role[0];
            this.permissions = this.$store.state.auth.permissions;
            this.getRoles();
            this.$store.dispatch('activeTap', 'roles');
        },
        components: {
            TableComponent,
            'Pagination': LaravelVuePagination
        },
        methods:{
            getRoles: async function (page = 1) {
                try {
                    const response = await roles.index(this.search, this.sort === false ? this.sort = 'desc' : this.sort, page);
                    console.log(response);
                    this.roles = response.data.data;
                    this.laravelData = response.data;
                    this.originalRoles = response.data.data;

                } catch (e) {
                    console.log(e);
                    this.error = e;
                }
            },
            updateRole(e) {
                let filteredData = this.roles.filter(function (data) {
                    return data.id != e;
                });
                this.roles = filteredData;
            },
            searchHandler(e) {
                this.isSearch = true;
                // let serachedValue = e.target.value.toLowerCase();
                // let searchedData = null;
                //
                // if (serachedValue !== '') {
                //     this.isSearch = true;
                // } else {
                //     this.isSearch = false;
                // }
                // searchedData = this.originalRoles.filter((data) =>  data.name.toLowerCase().indexOf(serachedValue) >= 0);
                // this.roles = searchedData;
            },
            async searchBackEndHandler(searchFlag = false) {
                let dataLength = this.roles.length;
                if (searchFlag && dataLength > 0) {
                    await this.getRoles(searchFlag);
                }
            },
            SortRole() {
                let status = !this.state;
                this.originalRoles.sort(function (a, b) {
                    return status ? -(a.id - b.id || a.name.localeCompare(b.name)) : -(b.id - a.id || b.name.localeCompare(a.name));
                });
                this.state = status;
            }
        }
    }
</script>

<style scoped>
    /*.tabcontent {*/
    /*    border: 1px solid #032431;*/
    /*    background-color: #032431;*/
    /*    border-radius: 20px;*/
    /*    padding: 23px;*/
    /*}*/
</style>